import { Injectable } from '@angular/core';
import {IOfflineBasketItem} from 'src/app/basket/models/basket'
const PRODUCT_ARRAY = 'products';

@Injectable({
  providedIn: 'root'
})
export class OfflineBasketStorageService {
  constructor() { }

  public addProduct(basketItem : IOfflineBasketItem): void{
    var localBasketItems : IOfflineBasketItem[] = [];

    if(this.getProducts()){
      localBasketItems = JSON.parse(this.getProducts());

      var indexOfExisitingProduct = localBasketItems.findIndex(x => x.internalNumber == basketItem.internalNumber)
      if(indexOfExisitingProduct >= 0){
        localBasketItems[indexOfExisitingProduct] = {internalNumber: basketItem.internalNumber, quantity: localBasketItems[indexOfExisitingProduct].quantity + basketItem.quantity, companyId: null}
      } else {
        localBasketItems.push(basketItem);
      }
    } else {
      localBasketItems.push(basketItem);
    }
       
    window.localStorage.setItem(PRODUCT_ARRAY, JSON.stringify(localBasketItems));
  }

  public getProducts() : string | null{
    return window.localStorage.getItem(PRODUCT_ARRAY);
  }

  public getProductsAsArray() : IOfflineBasketItem[] | null{
    return JSON.parse(window.localStorage.getItem(PRODUCT_ARRAY));
  }

  public removeProduct(internalNumber: string){

    if(this.getProducts()){
      var localBasketItems = JSON.parse(this.getProducts());
      var index = localBasketItems.findIndex(x => x.internalNumber == internalNumber)
      localBasketItems.splice(index, 1)

      window.localStorage.setItem(PRODUCT_ARRAY, JSON.stringify(localBasketItems));
    }

  }

  public updateProdct(basketItem : IOfflineBasketItem){
    if(this.getProducts()){
      var localBasketItems = JSON.parse(this.getProducts());
      var index = localBasketItems.findIndex(x => x.internalNumber == basketItem.internalNumber)
      localBasketItems[index] = basketItem;

      window.localStorage.setItem(PRODUCT_ARRAY, JSON.stringify(localBasketItems));
    }
  }

  public removeAllProducts(){
    window.localStorage.removeItem(PRODUCT_ARRAY);
  }
}